// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3I82J","rootSuccess":"CompleteLink_rootSuccess__2wpuG","rootFailure":"CompleteLink_rootFailure__nxd_e","isDisabled":"CompleteLink_isDisabled__1pDTX"};